import { Pipe, PipeTransform } from '@angular/core';
import {
    DomSanitizer,
    SafeStyle,
    SafeResourceUrl,
    SafeScript,
    SafeHtml,
    SafeUrl
} from '@angular/platform-browser';

export type PipeSafeType
    = 'html'
    | 'style'
    | 'script'
    | 'url'
    | 'resourceUrl';

@Pipe({
    name: 'pipeSafe',
    pure: true
})
export class PipeSafe implements PipeTransform {
    constructor(protected sanitizer: DomSanitizer) { }

    public transform(value: string, type: PipeSafeType): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
        switch (type) {
            case 'html':
                return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new Error(`SafePipe unable to bypass security for invalid type: ${type}`);
        }
    }
}

@Pipe({name: 'safeHTML'})
export class SafeHTMLPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }
    public transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
